// src/pages/admin/AdminUsers.js
// Gestion des utilisateurs (admin) - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ROUTES from '../../constants/routes';

const AdminUsers = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    // Données de démo (à remplacer par adminUsersAPI.getAll())
    const demoUsers = [
      { id: 1, name: 'Jean Kamga', email: 'jean.kamga@email.com', phone: '+237690000001', favoritesCount: 3, joinedAt: '2026-05-12' },
      { id: 2, name: 'Marie Ndongo', email: 'marie.n@email.com', phone: '+237690000002', favoritesCount: 1, joinedAt: '2026-06-01' },
      { id: 3, name: 'Paul Fotso', email: 'paul.fotso@email.com', phone: '+237690000003', favoritesCount: 5, joinedAt: '2026-06-20' },
    ];
    setUsers(demoUsers);
  }, []);

  const filtered = users.filter(
    (u) =>
      !search ||
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = (userId) => {
    if (window.confirm('Supprimer cet utilisateur ? Cette action est irréversible.')) {
      // TODO: adminUsersAPI.delete(userId)
      setUsers((prev) => prev.filter((u) => u.id !== userId));
    }
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: '900px', margin: '0 auto', backgroundColor: '#0A0E1A' },
    header: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', position: 'sticky', top: 0, backgroundColor: '#0A0E1A', zIndex: 50 },
    backButton: { background: 'none', border: 'none', color: '#FFFFFF', fontSize: '20px', cursor: 'pointer' },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    searchInput: { margin: '16px 20px', padding: '12px 16px', backgroundColor: '#111827', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '8px', color: '#FFFFFF', fontSize: '14px', outline: 'none' },
    list: { display: 'flex', flexDirection: 'column', gap: '12px', padding: '0 20px 40px' },
    card: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', backgroundColor: '#162033', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.1)' },
    avatar: { width: '48px', height: '48px', borderRadius: '50%', backgroundColor: 'rgba(66, 153, 225, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 },
    body: { flex: 1 },
    name: { fontSize: '15px', fontWeight: '600', color: '#FFFFFF' },
    info: { fontSize: '13px', color: '#A0AEC0', marginTop: '2px' },
    meta: { fontSize: '12px', color: '#4A5568', marginTop: '2px' },
    deleteBtn: { padding: '8px 12px', backgroundColor: 'rgba(245, 101, 101, 0.15)', color: '#F56565', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
    empty: { textAlign: 'center', padding: '48px', color: '#A0AEC0', fontSize: '14px' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Utilisateurs | Fynho Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(ROUTES.ADMIN_DASHBOARD)}>←</button>
        <div style={styles.title}>Utilisateurs ({users.length})</div>
      </div>

      <input
        type="text"
        style={styles.searchInput}
        placeholder="Rechercher un utilisateur..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div style={styles.list}>
        {filtered.length === 0 ? (
          <div style={styles.empty}>Aucun utilisateur trouvé</div>
        ) : (
          filtered.map((user) => (
            <div key={user.id} style={styles.card}>
              <div style={styles.avatar}>👤</div>
              <div style={styles.body}>
                <div style={styles.name}>{user.name}</div>
                <div style={styles.info}>{user.email} · {user.phone}</div>
                <div style={styles.meta}>❤️ {user.favoritesCount} favoris · Inscrit le {user.joinedAt}</div>
              </div>
              <button style={styles.deleteBtn} onClick={() => handleDelete(user.id)}>Suppr.</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminUsers;